<script setup>
import CaretDownIcon from '@iconify-vue/ph/caret-down';
import TableIcon from '@iconify-vue/ph/table-fill';
import { AnimatePresence, Motion } from 'motion-v';
import {
    PopoverContent,
    PopoverPortal,
    PopoverRoot,
    PopoverTrigger,
} from 'reka-ui';
import { ref } from 'vue';

const {
    selectAllVisible,
    selectAll,
    selectionSize,
    align = 'left',
} = defineProps({
    selectAllVisible: {
        type: Function,
        required: true,
    },
    selectAll: {
        type: Function,
        required: true,
    },
    selectionSize: {
        type: Function,
        required: true,
    },
    align: {
        type: String,
        required: false,
        default: 'left',
    },
});

const isOpen = ref(false);

function handleSelectAllVisible() {
    selectAllVisible();
    isOpen.value = false;
}

function handleSelectAll() {
    selectAll();
    isOpen.value = false;
}
</script>

<template>
    <div
        class="relative inline-flex w-full items-center gap-2"
        :class="{
            'justify-start': align === 'left',
            'justify-center text-center': align === 'center',
            'justify-end': align === 'right',
        }"
    >
        <PopoverRoot v-model:open="isOpen">
            <PopoverTrigger
                class="flex h-6 items-center justify-between gap-2 rounded border border-gray-500 px-2 py-1 text-left text-xs duration-150 hover:bg-indigo-600 hover:text-white"
            >
                <TableIcon class="size-4" />

                <template v-if="selectionSize() > 0">
                    {{ selectionSize() }}
                </template>
                <template v-else> &nbsp; </template>

                <CaretDownIcon class="size-4" />
            </PopoverTrigger>

            <PopoverPortal>
                <PopoverContent
                    force-mount
                    :side-offset="4"
                    align="start"
                    class="z-50"
                >
                    <AnimatePresence>
                        <Motion
                            v-if="isOpen"
                            :initial="{ opacity: 0, y: -4 }"
                            :animate="{ opacity: 1, y: 0 }"
                            :exit="{ opacity: 0, y: -4 }"
                            :transition="{ duration: 0.15 }"
                            class="w-[240px] overflow-hidden rounded border border-gray-300 bg-white shadow-sm"
                        >
                            <button
                                type="button"
                                class="block w-full cursor-pointer px-3 py-1 text-left text-sm duration-150 hover:bg-indigo-600 hover:text-white"
                                @click="handleSelectAllVisible"
                            >
                                Sélectionner les éléments visibles
                            </button>

                            <button
                                type="button"
                                class="block w-full cursor-pointer px-3 py-1 text-left text-sm duration-150 hover:bg-indigo-600 hover:text-white"
                                @click="handleSelectAll"
                            >
                                Tout sélectionner
                            </button>
                        </Motion>
                    </AnimatePresence>
                </PopoverContent>
            </PopoverPortal>
        </PopoverRoot>
    </div>
</template>
